import { useUser } from '@shared/hooks/use-user.ts';

export const useIsAuthor = ({ authorId }: { authorId?: number }) => {
  const { user } = useUser();
  return {
    isAuthor: Boolean(authorId && user?.id && authorId === user.id),
  };
};
